import { useRouteError, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardHeader,
  H1,
} from "@datapay-by-datacom/design-system";
import s from "./ErrorBoundary.module.css";

export function RouterErrorBoundary() {
  const error = useRouteError() as Error;
  const navigate = useNavigate();

  useEffect(() => {
    console.error("Router error:", error);
  }, [error]);

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <div className={s.container}>
      <Card>
        <CardHeader>
          <H1>Something went wrong</H1>
        </CardHeader>
        <CardBody>
          <div className={s.routerCardContent}>
            <p className={s.description}>
              We encountered an unexpected error while loading this page.
            </p>

            <div className={s.buttonContainer}>
              <ButtonGroup>
                <Button variant="secondary" onPress={handleGoBack}>
                  Go Back
                </Button>
                <Button variant="primary" onPress={handleGoHome}>
                  Go Home
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
